export default "__VITE_ASSET__Cpx5bsna__"